import React from 'react';

var styles = {"component":"pagination__component_14kdr"};
require('./index.css');

var PerPageView = function (_a) {
    var pagesCount = _a.pagesCount, currentPageIndex = _a.currentPageIndex;
    return (React.createElement("span", { className: styles.component },
        currentPageIndex + 1,
        " \u0438\u0437 ",
        pagesCount,
        " \u0441\u0442\u0440\u0430\u043D\u0438\u0446"));
};

export { PerPageView };
